import React, { useEffect, useState } from "react";
import api, { formatINR } from "../../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { toast } from "sonner";

const STATUSES = ["pending", "confirmed", "in_progress", "completed", "cancelled"];

export default function AdminOrders() {
  const [tab, setTab] = useState("all");
  const [orders, setOrders] = useState([]);

  const load = (s) => {
    const url = s === "all" || !s ? "/admin/orders" : `/admin/orders?status=${s}`;
    api.get(url).then((r) => setOrders(r.data));
  };
  useEffect(() => { load(tab); }, [tab]);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}/status`, { status });
    toast.success(`Status: ${status}`); load(tab);
  };

  return (
    <div data-testid="admin-orders">
      <h1 className="font-serif-display text-4xl mb-8">Orders</h1>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="all" data-testid="tab-all">All</TabsTrigger>
          {STATUSES.map((s) => <TabsTrigger key={s} value={s} data-testid={`tab-${s}`}>{s.replace("_", " ")}</TabsTrigger>)}
        </TabsList>
        <TabsContent value={tab} className="mt-6">
          <div className="bg-background rounded-2xl border border-border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-muted text-left text-xs uppercase tracking-widest">
                <tr><th className="p-3">Customer</th><th className="p-3">Phone</th><th className="p-3">Event</th><th className="p-3">Date</th><th className="p-3">Package</th><th className="p-3">Total</th><th className="p-3">Status</th></tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id} className="border-t border-border" data-testid={`order-${o.id}`}>
                    <td className="p-3">{o.name}</td>
                    <td className="p-3 text-muted-foreground">{o.phone}</td>
                    <td className="p-3">{o.event_type}</td>
                    <td className="p-3">{o.event_date}</td>
                    <td className="p-3 text-xs">{o.package_title}</td>
                    <td className="p-3 font-medium">{formatINR(o.total)}</td>
                    <td className="p-3">
                      <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="text-xs rounded-md border border-input bg-background px-2 py-1" data-testid={`status-${o.id}`}>
                        {STATUSES.map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
                {orders.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-muted-foreground">No orders</td></tr>}
              </tbody>
            </table>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
